import { JsonLd } from 'react-schemaorg';
import { HowTo } from 'schema-dts';

import { IBuildHowToJsonLdOptions, buildHowToJsonLd } from './helpers';

/**
 * Renders `<JsonLd<HowTo>>` when a valid schema can be built, `null` otherwise.
 * Keeps consumer JSX clean and centralizes the "no name → no schema" rule so a
 * future bug fix only needs to touch one place.
 */
function HowToSchema(props: IBuildHowToJsonLdOptions) {
  const jsonLd = buildHowToJsonLd(props);
  if (!jsonLd) return null;
  return <JsonLd<HowTo> item={jsonLd} />;
}

export default HowToSchema;
